import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';

import { closeContactSidebar } from 'store/v1/ui/ui.actions.js';
import { unarchiveContact } from 'store/v1/contacts/contacts.actions.js';
import { myServices } from 'v5/services/services.connected.app';

import SidebarDraw from 'v1/components/frame/SidebarDraw/SidebarDraw';
import ResourcePane from 'v1/components/feature/ResourceComponents/ResourcePane/ResourcePane';
import { Loading } from 'v1/components/shared';
import { ArchivedBanner } from '~/v5/patterns/widgets/ArchivedBanner.js';

const ResourceSidebarDrawer = () => {
  const dispatch = useDispatch();
  const { showContactSidebar, selectedContact } = useSelector(
    state => state.ui
  );

  const closeSidebar = () => dispatch(closeContactSidebar());

  const handleUnarchive = () => {
    dispatch(unarchiveContact(selectedContact.id))
      .then(() => {
        myServices.toastService.open({
          type: 'success',
          message: 'Resource unarchived'
        });
      })
      .catch(error => {
        myServices.toastService.open({
          type: 'error',
          message: 'Failed to unarchive the resource.'
        });
        console.error('Failed to unarchive the resource.', error);
      });
  };

  return (
    <SidebarDraw isOpen={showContactSidebar} closeSidebar={closeSidebar}>
      <div className="SidebarDraw-flex-container">
        {selectedContact?.archived && (
          <ArchivedBanner onUnarchive={handleUnarchive} assetName="resource" />
        )}
        <div className="SidebarDraw-flex-content">
          {!isEmpty(selectedContact) ? (
            <ResourcePane resource={selectedContact} detailsPadded />
          ) : (
            <Loading />
          )}
        </div>
      </div>
    </SidebarDraw>
  );
};

ResourceSidebarDrawer.propTypes = {};

export default ResourceSidebarDrawer;
